import { ArtistContextIdFilterState } from './store/artistContextId.types';

export const artistContextIdFilterHash = (
  selectedArtistContextId: ArtistContextIdFilterState['selectedArtistContextId']
): string => String(selectedArtistContextId);
